module.exports = __webpack_public_path__ + "static/media/404-Error.9f2fa24f.svg";